import { ICharitableContribution } from 'src/commons';
import { CharitableContributionActionTypes, CharitableContributionActions } from './charitable-contribution.actions';

export interface State {
    error: string | null;
    pending: boolean;
    stateData: ICharitableContribution | null;
}

export const initialState: State = {
    error: null,
    pending: false,
    stateData: null
};

export function reducer(state = initialState, action: CharitableContributionActions): State {
    switch (action.type) {

        case CharitableContributionActionTypes.LoadCharitableContributionState: {
            return {
                ...state,
                error: null,
                pending: true
            };
        }

        case CharitableContributionActionTypes.LoadCharitableContributionStateSuccess: {
            return {
                error: null,
                pending: false,
                stateData: action.payload
            };
        }

        case CharitableContributionActionTypes.LoadCharitableContributionStateFail: {
            return {
                ...state,
                error: action.payload,
                pending: false
            };
        }

        case CharitableContributionActionTypes.CharitableContributionScreenErrorReset: {
            return {
                ...state,
                error: null,
                pending: false
            };
        } 

        default: {
            return state;
        }
    }
}

export const getError = (state: State) => state.error;
export const getPending = (state: State) => state.pending;
export const getStateData = (state: State) => state.stateData;